var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "\\u56FE\\u5C42 1",
    viewBox: "0 0 1024 1024"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M605.24 1046.59V574.64h159.22l23.67-184.79H605.24v-117.7c0-53.32 14.86-89.83 91.38-89.83h96.97V17.58c-47.18-5.1-94.61-7.54-142.06-7.31-140.73 0-237.36 85.91-237.36 243.64v135.61H255.99v184.79h158.53v472.3h190.72Z"
  })));
};
export default SvgFacebook;